import AppConstants from '@/appConstants';
import convertDatetimeHelper from '@/helpers/convert-datetime-helper';

class FormTemplate {
    flashesFields() {
        const fields = JSON.parse(JSON.stringify(formFields));
        fields.importance.required = true;
        fields.source.required = true;
        fields.channel.required = true;
        fields.title.required = true;
        fields.country.required = true;
        fields.hat.required = true;

        fields.layout = AppConstants.NEWS_LAYOUT.FLASHES;
        fields.importance.display = true;
        fields.hat.display = true;
        fields.channel.display = true;
        fields.typeMessage.display = true;
        fields.source.display = true;
        fields.subjects.display = true;
        fields.tags.display = true;
        fields.listFlashes.display = true;
        fields.title.display = true;
        // fields.related_news.display = true;
        fields.country.display = true;
        fields.language.display = true;

        fields.weblink.display = true;

        return fields;
    }

    newsFields() {
        const fields = JSON.parse(JSON.stringify(formFields));
        fields.source.required = true;
        fields.channel.required = true;
        fields.title.required = true;
        fields.type_message_channel.required = true;
        fields.country.required = true;
        fields.hat.required = true;

        fields.layout = AppConstants.NEWS_LAYOUT.NEWS;
        fields.importance.display = true;
        fields.channel.display = true;
        fields.typeMessage.display = true;
        fields.source.display = true;
        fields.subjects.display = true;
        fields.tags.display = true;
        fields.hat.display = true;
        fields.title.display = true;
        fields.summary.display = true;
        fields.body.display = true;
        fields.thumb.display = true;
        fields.thumbPodcast.display = true;
        fields.thumbVideo.display = true;
        fields.image.display = true;
        fields.document.display = true;
        fields.audio.display = true;
        // fields.related_news.display = true;
        fields.highlight.display = true;
        fields.highlight_date.display = true;
        // fields.sharedSources.display = true;
        fields.category.display = true;

        fields.signatures.display = true;
        fields.userHeader.display = true;
        fields.library.display = true;

        fields.audiofilename.display = true;
        fields.youtube.display = true;
        fields.soundcloud.display = true;
        fields.spotify.display = true;

        fields.newsContent.display = true;
        fields.weblink.display = true;

        fields.push.display = true;

        fields.type_message_channel.display = true;
        fields.country.display = true;
        fields.language.display = true;
        fields.clientGroup.display = true;

        fields.inLive.display = true;
        fields.inLive_validate.display = true;
        fields.image_description.display = true;

        fields.topic.display = true;
        fields.asset_reference.display = true;
        fields.enable_chart.display = true;
        fields.public_area.display = true;
        fields.dt_publish.display = true;

        return fields;
    }

    podcastFields() {
        const fields = JSON.parse(JSON.stringify(formFields));
        fields.source.required = true;
        fields.channel.required = true;
        fields.title.required = true;
        fields.country.required = true;
        // fields.audiofilename.required = true;
        fields.audio.required = true;
        fields.soundcloud.required = true;
        fields.spotify.required = true;
        fields.type_message_channel.required = true;
        fields.hat.required = true;

        fields.layout = AppConstants.NEWS_LAYOUT.PODCAST;
        fields.importance.display = true;
        fields.channel.display = true;
        fields.typeMessage.display = true;
        fields.source.display = true;
        fields.subjects.display = true;
        // fields.commodity.display = true;
        fields.tags.display = true;
        fields.hat.display = true;
        fields.title.display = true;
        fields.summary.display = true;
        fields.body.display = true;
        fields.thumb.display = true;
        fields.thumbPodcast.display = true;
        fields.thumbVideo.display = true;
        fields.image.display = true;
        fields.document.display = true;
        fields.audio.display = true;
        fields.youtube.display = true;
        fields.soundcloud.display = true;
        fields.spotify.display = true;
        fields.library.display = true;
        // fields.sharedSources.display = true;
        fields.category.display = true;
        fields.highlight.display = true;
        fields.highlight_date.display = true;
        fields.dt_publish.display = true;

        fields.country.display = true;
        fields.language.display = true;

        fields.newsContent.display = true;
        fields.audiofilename.display = true;
        fields.audioPodcast.required = true;
        fields.weblink.display = true;

        fields.push.display = true;

        fields.type_message_channel.display = true;
        fields.clientGroup.display = true;
        fields.image_description.display = true;

        fields.topic.display = true;
        fields.asset_reference.display = true;
        fields.enable_chart.display = true;
        fields.public_area.display = true;

        return fields;
    }

    tvFields() {
        const fields = JSON.parse(JSON.stringify(formFields));
        fields.source.required = true;
        fields.channel.required = true;
        fields.title.required = true;
        fields.country.required = true;
        fields.youtube.required = true;
        fields.type_message_channel.required = true;
        fields.hat.required = true;

        fields.layout = AppConstants.NEWS_LAYOUT.TVCAST;
        fields.importance.display = true;
        fields.channel.display = true;
        fields.typeMessage.display = true;
        fields.source.display = true;
        fields.subjects.display = true;
        // fields.commodity.display = true;
        fields.tags.display = true;
        fields.hat.display = true;
        fields.title.display = true;
        fields.summary.display = true;
        fields.body.display = true;
        fields.thumb.display = true;
        fields.thumbPodcast.display = true;
        fields.thumbVideo.display = true;
        fields.image.display = true;
        fields.document.display = true;
        fields.audio.display = true;
        fields.youtube.display = true;
        fields.soundcloud.display = true;
        fields.spotify.display = true;
        fields.library.display = true;
        fields.audiofilename.display = true;
        // fields.sharedSources.display = true;
        fields.category.display = true;
        fields.dt_publish.display = true;

        fields.country.display = true;
        fields.language.display = true;

        fields.highlight.display = true;
        fields.highlight_date.display = true;
        fields.image_copyright.display = true;

        fields.newsContent.display = true;
        fields.weblink.display = true;

        fields.push.display = true;

        fields.type_message_channel.display = true;
        fields.clientGroup.display = true;
        fields.image_description.display = true;

        fields.topic.display = true;
        fields.asset_reference.display = true;
        fields.enable_chart.display = true;
        fields.public_area.display = true;

        return fields;
    }

    reportFields() {
        const fields = JSON.parse(JSON.stringify(formFields));
        fields.source.required = true;
        fields.channel.required = true;
        fields.hat.required = true;
        fields.title.required = true;
        fields.country.required = true;
        fields.newsContent.required = true;
        fields.tags.display = true;
        // fields.reportType.required = true;
        // fields.package.required = true;
        // fields.characteristic.required = true;
        // fields.periodicity.required = true;
        // fields.document.required = true;
        // fields.dt_report.required = true;

        fields.layout = AppConstants.NEWS_LAYOUT.REPORT;
        fields.importance.display = true;
        fields.channel.display = true;
        fields.typeMessage.display = true;
        fields.source.display = true;
        fields.subjects.display = true;
        fields.hat.display = true;
        fields.title.display = true;
        fields.summary.display = true;
        fields.body.display = true;
        fields.library.display = true;
        fields.audio.display = true;
        fields.audiofilename.display = true;
        // fields.sharedSources.display = true;
        fields.category.display = true;

        // fields.commodity.display = true;
        fields.newsContent.display = true;
        fields.reportType.display = true;
        fields.package.display = true;
        fields.characteristic.display = true;
        fields.periodicity.display = true;
        fields.country.display = true;
        fields.language.display = true;
        fields.highlight.display = true;
        fields.highlight_date.display = true;
        fields.image_copyright.display = true;
        fields.dt_report.display = true;
        fields.dt_publish.display = true;
        // fields.download_document.display = true;
        fields.thumb.display = true;
        fields.thumbPodcast.display = true;
        fields.thumbVideo.display = true;
        fields.image.display = true;
        // fields.related_news.display = true;
        fields.signatures.display = true;
        fields.userHeader.display = true;

        fields.document.display = true;
        fields.youtube.display = true;
        fields.spotify.display = true;
        fields.weblink.display = true;
        fields.clientGroup.display = true;

        fields.push.display = true;
        fields.image_description.display = true;
        fields.soundcloud.display = true;

        fields.topic.display = true;
        fields.asset_reference.display = true;
        fields.enable_chart.display = true;
        fields.public_area.display = true;

        return fields;
    }

    eventFields() {
        const fields = JSON.parse(JSON.stringify(formFields));
        fields.source.required = true;
        fields.channel.required = true;
        fields.hat.required = true;
        fields.title.required = true;
        fields.country.required = true;
        
        fields.layout = AppConstants.NEWS_LAYOUT.EVENT;
        fields.importance.display = true;
        fields.channel.display = true;
        fields.typeMessage.display = true;
        fields.source.display = true;
        fields.subjects.display = true;
        fields.hat.display = true;
        fields.title.display = true;
        fields.summary.display = true;
        fields.body.display = true;
        fields.library.display = true;
        fields.audio.display = true;
        fields.audiofilename.display = true;
        // fields.sharedSources.display = true;
        fields.category.display = false;

        fields.newsContent.display = true;
        fields.country.display = true;
        fields.language.display = true;
        fields.highlight.display = true;
        fields.highlight_date.display = true;
        fields.image_copyright.display = true;
        fields.dt_report.display = false;
        // fields.download_document.display = true;
        fields.thumb.display = true;
        fields.image.display = true;
        // fields.related_news.display = true;
        fields.signatures.display = true;
        fields.userHeader.display = true;

        fields.document.display = true;
        fields.youtube.display = true;
        fields.spotify.display = true;
        fields.weblink.display = true;
        fields.soundcloud.display = true;
        fields.clientGroup.display = true;

        // event schedule fields
        fields.disclosureType.display = true;
        fields.eventScheduleType.display = true;
        fields.eventScheduleDuration_dateTo.display = true;
        fields.eventScheduleDuration_dateFrom.display = true;
        fields.eventScheduleDuration_hourTo.display = true;
        fields.eventScheduleDuration_hourFrom.display = true;
        fields.eventScheduleAllDay.display = true;
        fields.eventScheduleLocation.display = false;
        fields.eventSchedulePrice.display = true;
        fields.eventScheduleLink.display = true;
        fields.eventScheduleRelatedNews.display = true;

        fields.image_description.display = true;

        fields.topic.display = true;
        fields.public_area.display = true;
        fields.dt_publish.display = true;

        fields.reportType.display = true;
        
        return fields;
    }

    getFormEmpty() {
        return formFields;
    }
}

const formFields = {
    layout: null,

    sharedSources: { display: false, value: [], required: false },
    category: { display: false, value: [], required: false },
    channel: { display: false, value: [], required: false },
    importance: { display: false, value: false, required: false },
    typeMessage: { display: false, value: '', required: false },
    source: { display: false, value: '', required: false },
    subjects: { display: false, value: [], required: false },
    tags: { display: false, value: [], required: false },
    hat: { display: false, value: [], required: false },
    title: { display: false, value: '', required: false },
    summary: { display: false, value: '', required: false },
    audiofilename: { display: false, value: '', required: false },
    audioPodcast: { display: false, value: '', required: false },
    body: { display: false, value: '', required: false },
    thumb: { display: false, value: null, required: false },
    thumbPodcast: { display: false, value: null, required: false },
    thumbVideo: { display: false, value: null, required: false },
    video: { display: false, value: null, required: false },
    image: { display: false, value: null, required: false },
    document: { display: false, value: null, required: false },
    audio: { display: false, value: null, required: false },
    youtube: { display: false, value: '', required: false },
    soundcloud: { display: false, value: '', required: false },
    spotify: { display: false, value: '', required: false },
    active: { display: false, value: true, required: false },
    weblink: { display: false, value: '', required: false },
    clientGroup: { display: false, value: [], required: false },

    // NEWS, FLASHES FIELDS
    listFlashes: { display: false, value: [], required: false },
    related_news: { display: false, value: [], required: false },

    signatures: { display: false, value: '', required: false },
    contentFooter: { display: false, value: '', required: false },
    userHeader: { display: false, value: '', required: false },
    library: { display: false, value: '', required: false },


    // REPORT FIELDS
    // commodity: { display: false, value: '' },
    newsContent: { display: false, value: [], required: false },
    reportType: { display: false, value: '', required: false },
    package: { display: false, value: '', required: false },
    characteristic: { display: false, value: '', required: false },
    periodicity: { display: false, value: '', required: false },
    country: { display: false, value: '', required: false },
    language: { display: false, value: '', required: false },
    highlight: { display: false, value: false, required: false },
    highlight_date: { display: false, value: '', required: false },
    
    download_document: { display: false, value: true, required: false },
    dt_report: { display: false, value: new Date(), required: false },
    dt_publish: { display: false, value: '', required: false },

    ignored_by_ai: { display: true, value: false, required: false },

    // APP FIELDS
    push: { display: false, value: false, required: false },
    image_copyright: { display: false, value: '', required: false },
    external_url: { display: false, value: '', required: false },
    external_label_btn: { display: false, value: '', required: false },

    youtube_title: { display: false, value: '', required: false },
    youtube_description: { display: false, value: '', required: false },

    // NOT DISPLAY
    _id: { display: false, value: '', required: false },
    event_status: { display: false, value: 0, required: false },
    dt_scheduled: { display: false, value: null, required: false },
    hour_schedule: { display: false, value: null, required: false },
    draftId: { display: false, value: null, required: false },
    image_description: { display: false, value: '', required: false },
    
    type_message_channel: { display: false, value: AppConstants.TYPE_MESSAGE_CHANNEL[0], required: false },

    inLive: {display: false, value: false, required: false},
    inLive_validate: {display: false, value: '', required: false},
    
    generate_thumb: {display: false, value: true, required: false},

    compressPdf: {display: false, value: false, required: false},

    // EVENT SCHEDULE
    disclosureType: {display: false, value: 1, required: false},
    eventScheduleType: {display: false, value: 1, required: false},
    eventScheduleDuration_dateTo: {display: false, value: convertDatetimeHelper.getDateD1RangeFilterFormat(), required: false},
    eventScheduleDuration_hourTo: {display: false, value: '', required: false},
    eventScheduleDuration_dateFrom: {display: false, value: convertDatetimeHelper.getDateD1RangeFilterFormat(), required: false},
    eventScheduleDuration_hourFrom: {display: false, value: '', required: false},
    eventScheduleAllDay: {display: false, value: false, required: false},
    eventScheduleLocation: {display: false, value: '', required: false},
    eventScheduleLink: {display: false, value: '', required: false},
    eventSchedulePrice: {display: false, value: '', required: false},
    eventScheduleRelatedNews: {display: false, value: null, required: false},
    
    topic: {display: false, value: [], required: false},
    template_name: {display: false, value: '', required: false},
    
    public_area: {display: false, value: false, required: false},
    enable_chart: {display: true, value: false, required: false},

    asset_reference: {display: true, value: [], required: false},
    announcement_date: { display: false, value: '', required: false },
}

export default new FormTemplate()
